// extracted by mini-css-extract-plugin
module.exports = {"plant":"PlantItem_plant__3cwpJ","description":"PlantItem_description__1xZxq","price":"PlantItem_price__uHPa3"};